import type { ArticleVisual } from "../data/content";

export function ArticleVisuals({
  visuals,
  label
}: {
  visuals: ArticleVisual[];
  label: string;
}) {
  return (
    <section className="article-visuals" role="region" aria-label={label}>
      {visuals.map((visual, visualIndex) => (
        <figure
          className={`info-visual info-visual--${visual.type}`}
          key={visual.key}
        >
          <figcaption className="info-visual__header">
            <p className="info-visual__eyebrow">{visual.eyebrow}</p>
            <div>
              <span aria-hidden="true">
                {String(visualIndex + 1).padStart(2, "0")}
              </span>
              <h2>{visual.title}</h2>
            </div>
            <p>{visual.description}</p>
          </figcaption>
          <ol className="info-visual__items">
            {visual.items.map((item, itemIndex) => (
              <li key={`${visual.key}-${item.label}`}>
                {visual.type === "flow" ? (
                  <span className="info-visual__step" aria-hidden="true">
                    {String(itemIndex + 1).padStart(2, "0")}
                  </span>
                ) : null}
                <bdi className="info-visual__value">{item.value}</bdi>
                <h3>{item.label}</h3>
                <p>{item.note}</p>
              </li>
            ))}
          </ol>
        </figure>
      ))}
    </section>
  );
}
